<nz-modal
  [(nzVisible)]="visible"
  [nzTitle]="modalTitle"
  [nzFooter]="modalFooter"
  (nzOnCancel)="close()"
  [nzWidth]="720"
>
  <ng-template #modalTitle>
    <app-modal-title
      [icon]="isEdit ? 'edit' : 'plus-circle'"
      [title]="isEdit ? 'Editar Prospecto' : 'Nuevo Prospecto'"
    />
  </ng-template>

  <div *nzModalContent>
    <nz-spin [nzSpinning]="loadingData">
      <div class="form-layout">
        <!-- Columna izquierda: Formulario -->
        <div class="form-column">
          <!-- Drop zone CIF: pre-llena campos y guarda la Constancia Fiscal -->
          <div
            class="cif-slot"
            [class.cif-slot--dragging]="cifDragging"
            [class.cif-slot--uploading]="cifUploading"
            [class.cif-slot--loaded]="!!cifFileName && !cifUploading && !cifError"
            [class.cif-slot--error]="!!cifError"
            (click)="!cifUploading && cifFileInput.click()"
            (dragover)="onCifDragOver($event)"
            (dragleave)="onCifDragLeave($event)"
            (drop)="onCifDrop($event)"
          >
            <input
              #cifFileInput
              type="file"
              accept=".pdf,.png,.jpg,.jpeg,application/pdf,image/png,image/jpeg"
              hidden
              (change)="onCifFileSelected($event)"
            />

            @if (cifUploading) {
              <div class="cif-slot-content">
                <span nz-icon nzType="loading" class="cif-slot-icon cif-slot-icon--uploading"></span>
                <span class="cif-slot-label">Procesando CIF…</span>
                <span class="cif-slot-hint">{{ cifFileName }}</span>
              </div>
            } @else if (cifError) {
              <div class="cif-slot-content">
                <span nz-icon nzType="close-circle" class="cif-slot-icon cif-slot-icon--error"></span>
                <span class="cif-slot-label cif-slot-label--error">{{ cifError }}</span>
                <span class="cif-slot-hint">Haz clic o arrastra otro archivo para reintentar</span>
              </div>
            } @else if (cifFileName) {
              <div class="cif-slot-content">
                <span nz-icon nzType="check-circle" class="cif-slot-icon cif-slot-icon--success"></span>
                <span class="cif-slot-label cif-slot-label--success">¡CIF procesada!</span>
                <span class="cif-slot-hint">{{ cifFileName }}</span>
                <button
                  nz-button
                  nzType="link"
                  nzSize="small"
                  nzDanger
                  (click)="clearCifFile($event)"
                >
                  Limpiar
                </button>
              </div>
            } @else {
              <div class="cif-slot-content">
                <span nz-icon nzType="cloud-upload" class="cif-slot-icon cif-slot-icon--upload"></span>
                <span class="cif-slot-label">Arrastra o selecciona la CIF</span>
                <span class="cif-slot-hint">PDF o imagen (PNG/JPG), máx. 10 MB — pre-llena los datos y guarda la Constancia Fiscal</span>
              </div>
            }
          </div>

          <!-- Campos fijos -->
          <form nz-form [formGroup]="fixedForm" nzLayout="vertical">
            <nz-form-item>
              <nz-form-label nzRequired nzFor="nombre">Nombre</nz-form-label>
              <nz-form-control nzErrorTip="Nombre requerido (mínimo 2 caracteres)">
                <input nz-input formControlName="nombre" id="nombre" placeholder="Nombre del prospecto" />
              </nz-form-control>
            </nz-form-item>

            <div class="grid grid-cols-12 gap-x-3">
              <div class="col-span-12 md:col-span-6 lg:col-span-4">
                <nz-form-item>
                  <nz-form-label nzFor="rfc">RFC</nz-form-label>
                  <nz-form-control nzErrorTip="RFC inválido">
                    <input nz-input formControlName="rfc" id="rfc" placeholder="RFC (opcional)" />
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div class="col-span-12 md:col-span-6 lg:col-span-8">
                <nz-form-item>
                  <nz-form-label nzFor="email">Email</nz-form-label>
                  <nz-form-control nzErrorTip="Email inválido">
                    <input nz-input formControlName="email" id="email" placeholder="Email (opcional)" />
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>
          </form>

          <!-- Sección de agenda (solo en alta) -->
          @if (!isEdit) {
            <app-section-header title="Agenda" />

            @if (googleCal.accessToken$ | async) {
              <div class="google-status google-status--connected">
                <nz-icon nzType="check-circle" nzTheme="fill" />
                <span>Google conectado</span>
              </div>
            } @else {
              <nz-alert
                nzType="warning"
                nzMessage="Google Calendar no conectado"
                nzDescription="Conecta tu cuenta de Google para registrar el evento en el calendario."
                [nzAction]="connectBtn"
                nzShowIcon
                class="mb-3"
              ></nz-alert>
              <ng-template #connectBtn>
                <button
                  nz-button
                  nzSize="small"
                  nzType="default"
                  type="button"
                  class="btn-connect-google"
                  [nzLoading]="connectingGoogle"
                  (click)="connectGoogle()"
                >
                  Conectar
                </button>
              </ng-template>
            }

            <form nz-form [formGroup]="agendaForm" nzLayout="vertical">
              <div class="grid grid-cols-12 gap-x-3">
                <div class="col-span-12 md:col-span-6">
                  <nz-form-item>
                    <nz-form-label nzRequired nzFor="agenda-fecha">Fecha</nz-form-label>
                    <nz-form-control nzErrorTip="La fecha es requerida">
                      <nz-date-picker
                        formControlName="fecha"
                        id="agenda-fecha"
                        nzPlaceHolder="Seleccionar fecha"
                        [nzDisabledDate]="disabledDate"
                        style="width: 100%"
                      ></nz-date-picker>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div class="col-span-12 md:col-span-6">
                  <nz-form-item>
                    <nz-form-label nzRequired nzFor="agenda-hora">Hora</nz-form-label>
                    <nz-form-control nzErrorTip="La hora es requerida">
                      <nz-time-picker
                        formControlName="hora"
                        id="agenda-hora"
                        nzPlaceHolder="Seleccionar hora"
                        nzFormat="HH:mm"
                        [nzMinuteStep]="10"
                        [nzDisabledHours]="disabledHours"
                        [nzDisabledMinutes]="disabledMinutes"
                        style="width: 100%"
                      ></nz-time-picker>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>

              <nz-form-item>
                <nz-form-label nzFor="agenda-slink">Enlace de reunión (opcional)</nz-form-label>
                <nz-form-control nzErrorTip="Debe ser un enlace de Meet, Zoom o Teams (https://...)">
                  <input
                    nz-input
                    formControlName="slink"
                    id="agenda-slink"
                    placeholder="https://meet.google.com/... | https://zoom.us/... | https://teams.microsoft.com/..."
                  />
                </nz-form-control>
              </nz-form-item>

              <nz-form-item style="display:none">
                <nz-form-label nzFor="agenda-duracion">Duración (minutos)</nz-form-label>
                <nz-form-control>
                  <input
                    nz-input
                    formControlName="duracion"
                    id="agenda-duracion"
                    type="number"
                    min="15"
                    max="999"
                    maxlength="3"
                    placeholder="Duración en minutos"
                    (keydown)="onDuracionKeydown($event)"
                    (input)="onDuracionInput($event)"
                  />
                  <span class="field-hint">Si no se indica, se usará 1 hora por defecto</span>
                </nz-form-control>
              </nz-form-item>
            </form>
          }

          <!-- Campos extra arrastrados (zona drop) -->
          <div
            cdkDropList
            #formList="cdkDropList"
            [cdkDropListData]="activeFields"
            [cdkDropListConnectedTo]="[panelList]"
            (cdkDropListDropped)="onDropToForm($event)"
            class="drop-zone"
            [class.drop-zone-empty]="activeFields.length === 0"
          >
            @if (activeFields.length === 0) {
              <div class="drop-hint">
                <nz-icon nzType="drag" nzTheme="outline" />
                <span>Arrastra campos aquí para llenarlos</span>
              </div>
            }
            <form nz-form [formGroup]="extraForm" nzLayout="vertical">
              @for (field of activeFields; track field.key; let i = $index) {
                <div cdkDrag class="active-field">
                  <div class="active-field-header">
                    <nz-icon nzType="holder" nzTheme="outline" class="drag-handle" cdkDragHandle />
                    <button
                      nz-button
                      nz-tooltip
                      nzTooltipTitle="Quitar campo"
                      class="remove-btn"
                      (click)="removeField(i)"
                    >
                      <nz-icon nzType="close" />
                    </button>
                  </div>
                  <nz-form-item>
                    <nz-form-label [nzFor]="field.key">{{ field.label }}</nz-form-label>
                    <nz-form-control [nzErrorTip]="field.errorTip ?? ''">
                      @switch (field.type) {
                        @case ('text') {
                          <input
                            nz-input
                            [formControlName]="field.key"
                            [id]="field.key"
                            [placeholder]="field.placeholder ?? ''"
                            [attr.maxlength]="field.maxLength ?? null"
                          />
                        }
                        @case ('number') {
                          <nz-input-number
                            [formControlName]="field.key"
                            [id]="field.key"
                            [nzPlaceHolder]="field.placeholder ?? ''"
                            [nzMin]="field.min ?? 0"
                            [nzMax]="field.max ?? 9999999"
                            style="width: 100%"
                          />
                        }
                        @case ('select') {
                          <nz-select
                            [formControlName]="field.key"
                            [id]="field.key"
                            [nzMode]="field.selectMode ?? 'default'"
                            [nzPlaceHolder]="field.placeholder ?? ''"
                            [nzLoading]="(loadingTaxRegimes && field.key === 'regimenesfiscales') || (loadingBrokers && field.key === 'idBroker')"
                            nzShowSearch
                            style="width: 100%"
                          >
                            @if (field.key === 'regimenesfiscales') {
                              @for (opt of taxRegimeOptions; track opt.value) {
                                <nz-option [nzValue]="opt.value" [nzLabel]="opt.label" />
                              }
                            } @else if (field.key === 'idBroker') {
                              @for (opt of brokerOptions; track opt.value) {
                                <nz-option [nzValue]="opt.value" [nzLabel]="opt.label" />
                              }
                            }
                          </nz-select>
                        }
                      }
                    </nz-form-control>
                  </nz-form-item>
                  <div *cdkDragPlaceholder class="drag-placeholder"></div>
                </div>
              }
            </form>
          </div>
        </div>

        <!-- Columna derecha: Panel de campos disponibles -->
        <div class="panel-column">
          <div class="panel-title">Campos disponibles</div>
          <div
            cdkDropList
            #panelList="cdkDropList"
            [cdkDropListData]="availableFields"
            [cdkDropListConnectedTo]="[formList]"
            (cdkDropListDropped)="onDropToPanel($event)"
            class="panel-list"
          >
            @for (field of availableFields; track field.key) {
              <div cdkDrag class="panel-item">
                <nz-icon nzType="holder" nzTheme="outline" class="panel-drag-icon" />
                <div class="panel-item-info">
                  <span class="panel-item-label">{{ field.label }}</span>
                  <span class="panel-item-group">{{ field.group }}</span>
                </div>
                <div *cdkDragPlaceholder class="drag-placeholder-small"></div>
              </div>
            }
            @if (availableFields.length === 0) {
              <div class="panel-empty">Todos los campos están en uso</div>
            }
          </div>
        </div>
      </div>
    </nz-spin>
  </div>

  <ng-template #modalFooter>
    <div class="modal-footer">
      <button nz-button class="sinay-outline-reset" (click)="close()">Cancelar</button>
      <button
        nz-button
        class="btn-add"
        [nzLoading]="saving"
        [disabled]="!isEdit && !googleConnected"
        (click)="save()"
      >
        {{ isEdit ? 'Guardar' : 'Crear' }}
      </button>
    </div>
  </ng-template>
</nz-modal>
